import * as React from "react";
import { List, Datagrid, TextField, Filter, TextInput } from 'react-admin';
import { MyPagination } from './pagination';


export const LoterieFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Дата" source="date" defaultValue="18.03.2025" />
    </Filter>
);

export const LoterieList = (props) => (
    <List {...props} title='Лотерейные билеты' pagination={<MyPagination/>} filters={<LoterieFilter/>}>
        <Datagrid rowClick="show">
            <TextField source="id" label="ID" sortable={false} />
            <TextField source="shopid" label="ID магазина" sortable={false} />
            <TextField source="barcode" label="Баркод" sortable={false} />
            <TextField source="date" label="Дата" sortable={false} />
            <TextField source="count" label="Кол-во" sortable={false} />
        </Datagrid>
    </List>
);
